import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

cartHeaderStyles.gridItem1 = {
    width: [10, 10, 8, 9, 9],	
        css: css`	
            > div > h1 {	
                margin-bottom: 0 !important;
                color: ${COLORS.primary.base} !important;	
                font-family: ${TYPOGRAPHY.fontFamily.title};	
                font-style: normal;	
                font-weight: ${TYPOGRAPHY.weight.mediumbold};	
                font-size: ${TYPOGRAPHY.size.xxlarge};	
                line-height: ${TYPOGRAPHY.lineHeight.xlmedium};	
            }	
        `,
};